import {Controller} from "@hotwired/stimulus"
import * as bootstrap from "bootstrap";
import {Modal} from "bootstrap";
import {createMapEventOccurrenceElement} from "./createMapEventOccurrenceElement";

export default class extends Controller {
  static targets = ["sidebar", "modal"]
  static values = { url: String };

  declare readonly sidebarTarget: HTMLElement;
  declare readonly modalTarget: HTMLElement;

  declare readonly urlValue: string;

  private modalElement: Modal | null = null;

  connect() {
    console.log('Selected event occurrences controller connected');

    this.modalElement = new bootstrap.Modal(
      this.modalTarget, {
        backdrop: 'static',
        keyboard: false
      });

    this.modalTarget.addEventListener('hidePrevented.bs.modal', this.closeModal.bind(this));

    document.addEventListener('map-point-selected', ((event: CustomEvent<number[]>) => {
      let params = new URLSearchParams({});
      event.detail?.map(eventOccurrenceId => {
        params.append('ids[]', eventOccurrenceId.toString());
      });

      fetch(`${this.urlValue}?${params.toString()}`)
        .then(response => response.json())
        .then((eventOccurrences) => {
          const fragment = document.createDocumentFragment();
          for (const jsonItem of eventOccurrences) {
            const eventOccurrenceElement = createMapEventOccurrenceElement(jsonItem);
            if (eventOccurrenceElement) fragment.append(eventOccurrenceElement);
          }

          if (window.matchMedia("(max-width: 768px)").matches) {
            const modalEventOccurrencesContent = this.modalTarget.querySelector('#modal-event-occurrences-content');
            if (modalEventOccurrencesContent) modalEventOccurrencesContent.replaceChildren(fragment);
            this.openModel();
          } else {
            const sidebarEventOccurrencesContainer = this.sidebarTarget.querySelector('#sidebar-event-occurrences-container');
            if (sidebarEventOccurrencesContainer) sidebarEventOccurrencesContainer.replaceChildren(fragment);
            this.sidebarTarget.classList.add('active');
          }
        })
        .catch(error => console.error('Error fetching records:', error));
    }) as EventListener);
  }

  disconnect() {
    this.modalElement?.dispose();
  }

  closeEvents() {
    this.sidebarTarget.classList.remove('active');
    const sidebarEventOccurrencesContainer = this.sidebarTarget.querySelector('#sidebar-event-occurrences-container');
    if (sidebarEventOccurrencesContainer) sidebarEventOccurrencesContainer.innerHTML = '';
  }

  private openModel() {
    // event.preventDefault();
    this.modalElement?.show();
  }

  private closeModal() {
    this.modalElement?.hide();
  }
}